class UtilService {

    /***
     * Access an arbitrarily nested value within an object. For example, passing in the following values:
     * {abc: {def: 12345}}, ['abc', 'def']
     * will return 12345
     *
     * @param object            the object that you wish to search through
     * @param keyArray          an array of keys that will be used to search within th
     *
     * @returns {*} null if keyArray doesn't narrow down to a value within object, a nested property of object otherwise
     */
    getNestedProperty(object, keyArray) {
        let currentProp = object;
        for (let i in keyArray) {
            if (currentProp === undefined) {
                return null;
            }
            const key = keyArray[i];
            currentProp = currentProp[key]
        }
        return currentProp;
    }

}

export default UtilService;


// WEBPACK FOOTER //
// ./app/common/utils/utils-service.js